export default "__VITE_ASSET__LbDGhduI__"